class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.heading = this.querySelector('.accordion-item__heading-area');
    this.content = this.querySelector('.accordion-item__content');
    this.heading.addEventListener('click', () => this.toggleAccordion());
  }

  toggleAccordion() {
    document.querySelectorAll('accordion-item').forEach((item) => {
      if (item !== this) {
        item.classList.remove('open');
        item.collapse();
      }
    });

    if (this.classList.contains('open')) {
      this.classList.remove('open');
      this.collapse();
    } else {
      this.classList.add('open');
      this.expand();
    }
  }

  expand() {
    this.content.style.height = '0px';
    this.content.offsetHeight;
    this.content.style.height = this.content.scrollHeight + 'px';
  }

  collapse() {
    this.content.style.height = this.content.scrollHeight + 'px';
    this.content.offsetHeight;
    this.content.style.height = '0px';
  }
}

customElements.define('accordion-item', AccordionItem);